import { RefObject } from "react";

export function scrollIntoView(ref: RefObject<HTMLDivElement>) {
  if (ref && ref.current) {
    ref.current.scrollIntoView({ behavior: "smooth" });
  }
}
